import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { SelectAccountPageInitialData } from "./selectAccountPageInitialData";

export const selectAccountPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.selectAccount(),
    queryFn: () => fetchOccPageData<PageInitialDataResult<SelectAccountPageInitialData>>("/page-data/selectaccount"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
